<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    absolute
    left
    offset-x
    :disabled="disabled"
  >
    <v-btn
      slot="activator"
      icon
      :disabled="disabled"
      :width="width"
      class="ma-0"
      @click="showImageDialog"
    >
      <v-icon>publish</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <h2 class="title font-weight-bold">
          Загрузка файлов
        </h2>
      </v-card-title>
      <v-card-text class="py-0">
        <v-layout column>
          <v-layout
            v-for="image in images"
            :key="image.sourceName"
          >
            <v-flex
              xs6
              class="px-1"
            >
              <v-text-field
                v-model="image.originName"
                label="Имя вложения"
                hide-details
                @change="changeOriginName"
              />
            </v-flex>
            <v-flex
              xs6
              class="px-1"
            >
              <v-text-field
                disabled
                hide-details
                label="Имя файла"
                :value="image.sourceName"
              />
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          flat
          color="primary"
          :loading="uploadImagesLoading"
          @click="upload"
        >
          Ок
        </v-btn>
        <v-btn
          flat
          @click="close"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
import upload from "../attachments/upload.js";
import * as imagesApi from "../../backend/imagesApi.js";

export default {
  props: ["resource", "id", "disabled", "width"],
  data() {
    return {
      menu: false,
      images: [],
      uploadImagesLoading: false,
    };
  },
  methods: {
    showImageDialog() {
      upload().then(images => {
        this.images = this.images.concat(images);
        this.menu = true;
      });
    },
    async upload() {
      this.uploadImagesLoading = true;
      const items = this.images.map(i => {
        return {
          id: +this.id,
          originName: i.originName,
          data: i.data,
        };
      });
      await imagesApi.uploadImage(this.resource, +this.id, items);
      this.uploadImagesLoading = false;
      this.menu = false;
      this.images = [];
      this.showInfo("Фото добавлено");
      this.$emit("upload");
    },
    close() {
      this.menu = false;
      this.images = [];
    },
    changeOriginName(newValue) {
      this.images.forEach(image => {
        if (
          image.originName === newValue &&
          image.originName != image.sourceName
        ) {
          const splitSourceName = image.sourceName.split(".");
          const extention = splitSourceName[splitSourceName.length - 1];
          image.originName = newValue.includes(extention)
            ? newValue
            : `${newValue}.${extention}`;
        }
      });
    },
  },
};
</script>
